import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { PureComponent } from '../component';
import Button from '../Button';
import { getUidStr } from '../utils/uid';
import { modalClass } from './styles';
import Panel from './Panel';
import { getLocale } from '../locale';
import { getParent } from '../utils/dom/element';
import ready from '../utils/dom/ready';
import { docSize } from '../utils/dom/document';
import { isRTL, getDefaultContainer } from '../config';
var containers = {};
var DURATION = 300;

function getDiv(id) {
  var mod = containers[id];
  return mod ? mod.div : null;
}

function getContainer(id) {
  var mod = containers[id];
  return mod ? mod.container : null;
}

function hasVisibleMask() {
  return Object.keys(containers).some(function (k) {
    return containers[k].visible && !containers[k].props.hideMask;
  });
}

function isMask(id) {
  var ids = Object.keys(containers).filter(function (k) {
    return containers[k].visible && !containers[k].props.hideMask;
  });
  if (ids.length === 0) return true;
  return ids[0] === id;
}

export function destroy(id, unmount) {
  var div = getDiv(id);
  var container = getContainer(id);
  if (!div || !container) return;
  delete containers[id];
  if (unmount) ReactDOM.unmountComponentAtNode(div);
  if (div && div.parentNode) div.parentNode.removeChild(div);
}
export function close(props, callback) {
  var id = props.id;
  var modal = containers[props.id];
  if (!modal || modal.visible === false) return;
  modal.visible = false;
  var div = modal.div;
  div.classList.remove(modalClass('show'), modalClass('start'));
  if (!props.position) div.classList.add(modalClass('end'));
  setTimeout(function () {
    div.style.display = 'none';
    div.classList.remove(modalClass('end'));
    if (props.destroy) destroy(id, !props.usePortal);

    if (!hasVisibleMask()) {
      var doc = document.body.parentNode;
      doc.style.overflow = '';
      doc.style.paddingRight = '';
    }

    if (callback) callback();
  }, DURATION);
}
export function createDiv(props) {
  var defaultContainer = getDefaultContainer();
  var id = props.id,
      position = props.position,
      fullScreen = props.fullScreen,
      _props$container = props.container,
      container = _props$container === void 0 ? defaultContainer : _props$container,
      hideMask = props.hideMask;
  var div = getDiv(props.id);
  if (div) return div;
  var parent = typeof container === 'function' ? container() : container;
  div = document.createElement('div');
  parent.appendChild(div);
  div.className = classnames(modalClass('_', position && 'position', isRTL() && 'rtl', fullScreen && 'full-screen', hideMask && 'hide-mask'), props.rootClassName);
  containers[id] = {
    div: div,
    container: parent,
    props: props
  };
  return div;
} // eslint-disable-next-line

export function open(props, isPortal) {
  var content = props.content,
      onClose = props.onClose,
      zIndex = props.zIndex,
      forceMask = props.forceMask,
      otherProps = _objectWithoutProperties(props, ["content", "onClose", "zIndex", "forceMask"]);

  var options = _objectSpread2(_objectSpread2({}, props), {}, {
    usePortal: isPortal
  });

  var div = createDiv(options);
  div.style.display = 'block';
  var parsed = parseInt(String(zIndex), 10);
  if (!Number.isNaN(parsed)) div.style.zIndex = parsed;
  var doc = document.body.parentNode;

  if (!props.hideMask) {
    if (!doc.style.paddingRight) doc.style.paddingRight = "".concat(window.innerWidth - docSize.width, "px");
    doc.style.overflow = 'hidden';
  }

  var handleClose = function handleClose() {
    if (onClose) onClose();
    if (!isPortal) close(options);
  };

  var opacityDefault = props.maskOpacity === undefined ? 0.25 : props.maskOpacity;
  var maskOpacity = isMask(props.id) || forceMask ? opacityDefault : 0.01;
  if (!props.hideMask) div.style.background = props.maskBackground || "rgba(0,0,0,".concat(maskOpacity, ")");
  containers[props.id].visible = true;
  var panel =
  /*#__PURE__*/
  React.createElement(Panel, Object.assign({}, otherProps, {
    onClose: handleClose,
    container: div
  }), content);
  if (isPortal) return (
    /*#__PURE__*/
    ReactDOM.createPortal(panel, div)
  );
  if (document.activeElement && !getParent(document.activeElement, div)) document.activeElement.blur();
  ReactDOM.render(panel, div);
  return null;
}

var closeCallback = function closeCallback(fn, option, setLoading) {
  return function () {
    var callback;
    if (fn) callback = fn();

    if (callback && typeof callback.then === 'function') {
      if (setLoading) {
        setLoading(true);
      }

      callback.then(function () {
        close(option);
      })["catch"](function () {
        if (setLoading) {
          setLoading(false);
        }
      });
    } else {
      close(option);
    }
  };
};

var LoadingOk =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LoadingOk, _PureComponent);

  var _super = _createSuper2(LoadingOk);

  function LoadingOk(props) {
    var _this;

    _classCallCheck(this, LoadingOk);

    _this = _super.call(this, props);
    _this.setLoading = void 0;
    _this.state = {
      loading: false
    };

    _this.setLoading = function (loading) {
      _this.setState({
        loading: loading
      });
    };

    return _this;
  }

  _createClass(LoadingOk, [{
    key: "render",
    value: function render() {
      var option = this.props.option;
      var loading = this.state.loading;
      var onClick = closeCallback(option.onOk, option, this.setLoading);
      return (
        /*#__PURE__*/
        React.createElement(Button, {
          loading: loading,
          key: "ok",
          id: "".concat(option.id, "-ok"),
          onClick: onClick,
          type: "primary"
        }, getLocale('ok', option.text))
      );
    }
  }]);

  return LoadingOk;
}(PureComponent); // const btnOk = option => {
//   const onClick = closeCallback(option.onOk, option)
//   return (
//     <Button.Once key="ok" id={`${option.id}-ok`} onClick={onClick} type="primary">
//       {getLocale('ok', option.text)}
//     </Button.Once>
//   )
// }


var btnCancel = function btnCancel(option) {
  var onClick = closeCallback(option.onCancel, option);
  return (
    /*#__PURE__*/
    React.createElement(Button.Once, {
      id: "".concat(option.id, "-cancel"),
      key: "cancel",
      onClick: onClick
    }, getLocale('cancel', option.text))
  );
};

export var method = function method(type) {
  return function (option) {
    var props = Object.assign({
      width: 420,
      esc: true
    }, option, {
      id: getUidStr(),
      destroy: true,
      type: type,
      from: 'method'
    });

    if (type === 'confirm') {
      props.footer = [btnCancel(props),
      /*#__PURE__*/
      React.createElement(LoadingOk, {
        option: props,
        key: "ok"
      })];
    } else {
      props.footer = 'footer' in props ? props.footer : [
      /*#__PURE__*/
      React.createElement(LoadingOk, {
        option: props,
        key: "ok"
      })];
    }

    open(props);
    return function () {
      return close(props);
    };
  };
};
export var closeAll = function closeAll() {
  Object.keys(containers).filter(function (id) {
    return containers[id].props.from === 'method' && containers[id].visible;
  }).forEach(function (id) {
    var _containers$id$props = containers[id].props,
        onClose = _containers$id$props.onClose,
        usePortal = _containers$id$props.usePortal;
    if (onClose) onClose();
    if (!usePortal) close(containers[id].props);
  });
};
ready(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ids = Object.keys(containers).reverse();
    var opened = ids.find(function (id) {
      return containers[id].visible && containers[id].props.esc;
    });
    if (!opened) return;
    var props = containers[opened].props;
    var onClose = props.onClose,
        usePortal = props.usePortal;
    if (onClose) onClose();
    if (!usePortal) close(props);
  });
});